var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 50,
    viewBox: "0 0 510 510",
    width: 50,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m390 450h60v60h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m345.83 315h-15.83c0 41.355-33.645 75-75 75s-75-33.645-75-75h-15.83c-57.44 0-104.17 47.103-104.17 105h90v90h210v-90h90c0-57.897-46.73-105-104.17-105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60 450h60v60h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405 0h-165c-49.705 0-90 40.294-90 90h165c49.705 0 90-40.294 90-90z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m210.638 322.503c3.583 21.253 22.106 37.497 44.362 37.497s40.779-16.244 44.362-37.497c-28.198 9.839-59.616 10.156-88.724 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 300c57.897 0 105-47.103 105-105v-75c-7.023 0-205.087 0-210 0v75c0 57.897 47.104 105 105 105zm-30-105h60v30h-60z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRf);
export default __webpack_public_path__ + "static/media/rf.7982fab878953d68910da41adfe06d9e.svg";
export { ForwardRef as ReactComponent };